import React from 'react';
import { graphql, Link } from 'gatsby';

import Layout from "../components/layout";
import SEO from "../components/seo";

class NotFoundPage extends React.Component {
  render() {
    const { data, location } = this.props;
    const siteTitle = data.site.siteMetadata.title;

    return (
      <Layout title={siteTitle}>
        <SEO title="404: Not Found" location={ location } />
        <div className='main'>
          <h1>Not Found</h1>
          <p>You&apos;ve just discovered a page which hasn&apos;t been made yet.</p>
          <p><Link to='/'>Go home and try again.</Link></p>
        </div>
      </Layout>
    )
  }
}

export default NotFoundPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
